import styled from "@emotion/styled";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup
} from "@mui/material";
import { useField } from "formik";
import React, { useMemo } from "react";
import { I_GENERIC_ITEMS } from "../../../model/interface/items.interface";
import TextSimple from "../../typography/text-simple/TextSimple";
import { useYupContext } from "../../../context/RequiredFields.context";
interface RadioDuoFieldProps {
  option: I_GENERIC_ITEMS[];
  label: string;
  name: string;
  customrequired?: boolean;
}
function RadioDuoField(props: RadioDuoFieldProps) {
  const [field, meta, helper] = useField(props.name);
  const { requiredFields } = useYupContext();

  const ITEMS = useMemo(() => {
    return props.option;
  }, [props.option[0]?.value]);

  const value = useMemo(() => {
    return field.value?.length > 0 ? field.value[0].value : "";
  }, [field.value]);

  const handleChange = (e: I_GENERIC_ITEMS) => {
    helper.setValue([e]);
  };

  return (
    <Content>
      <ContentField>
        <CustonLabel
          customrequired={
            (requiredFields[props.name] || props.customrequired) ?? false
          }
          id={props.name + "-id"}
        >
          {props.label}
        </CustonLabel>
        <RadioGroupCustom
          row
          aria-labelledby={props.name + "-id"}
          name={props.name}
          value={value}
        >
          {props?.option?.map((item, i) => {
            return (
              <FormControlLabel
                key={i}
                value={item.value}
                onClick={() => handleChange(item)}
                control={<Radio />}
                label={item.label}
              />
            );
          })}
        </RadioGroupCustom>
      </ContentField>
      <div style={{ marginLeft: 10 }}>
        {meta.touched && (
          <TextSimple size="description" color="red" weight="500">
            {meta.error}
          </TextSimple>
        )}
      </div>
    </Content>
  );
}

export default RadioDuoField;

const CustonLabel = styled(FormLabel)<{ customrequired: boolean }>`
  white-space: nowrap;
  color: var(--m-color-blue-03);
  font-weight: 700;
  font-family: var(--ff-inter);
  font-size: 11px !important;
  ${props =>
    props.customrequired &&
    `
  ::after {
    content: " *";
    color: var(--m-color-red-01);
  }
  `}
`;

const ContentField = styled(FormControl)`
  width: 100%;
  height: calc(var(--height-input) + 16px);
  border: 1px solid var(--m-border-01);
  border-radius: 50px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0 10px;
  column-gap: 10px;
  justify-content: space-between;
  padding-left: 15px;
`;

const RadioGroupCustom = styled(RadioGroup)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  // column-gap: 10px;
  & .MuiFormControlLabel-label {
    margin-right: -5px;
    margin-left: -5px;
    color: var(--m-color-blue-03);
    font-weight: 600;
    font-family: var(--ff-inter);
    font-size: var(--fs-placeholder);
  }
  & .MuiTypography-root {
    color: var(--m-color-blue-03);
    font-weight: 600;
    font-family: var(--ff-inter);
    font-size: var(--fs-text-small);
  }
`;

const Content = styled.div`
  width: 100%;
  display: grid;
  grid-template-rows: repeat(1, minmax(0, 1fr));

  // row-gap: 10px;
`;
